import Vue from "vue"

export default new Vue()

export const FILE_UPLOAD_RESPONSE = "FILE_UPLOAD_RESPONSE"
